import { render } from "./CardRegist.vue?vue&type=template&id=19d93cc8"
import script from "./CardRegist.vue?vue&type=script&lang=js"
export * from "./CardRegist.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__